import { S as n } from "./chunk-SwiperElement-DayZ6j1H.js";
import { t as u } from "./chunk-custom-element-ttkHUa8w.js";
import { n as b } from "./chunk-property-Baio2yOX.js";
const g = `/*! tailwindcss v4.1.11 | MIT License | https://tailwindcss.com */
.swiper{--swiper-pagination-bottom:0px}.swiper-pagination-bullet.rlx-bullet{--swiper-pagination-bullet-horizontal-gap:8px;opacity:1;will-change:width;background:#d4d4d4;border-radius:4px;width:20px;height:4px;transition:width .3s cubic-bezier(.075,.82,.165,1)}.swiper-pagination-bullet-active.rlx-bullet{background:#12784a;width:50px}.swiper-pagination-bullet.rlx-bullet.rlx-bullet--offset{margin-bottom:calc(var(--spacing,.25rem)*3)}@media (min-width:48rem){.swiper-pagination-bullet.rlx-bullet.rlx-bullet--offset{margin-bottom:calc(var(--spacing,.25rem)*6)}}.swiper-pagination-bullet.rlx-bullet--dark{background-color:var(--color-rlx-dark,#212121)}.swiper-pagination-bullet.rlx-bullet--light{background-color:var(--color-rlx-light,#fff)}`;
var c = Object.defineProperty, d = Object.getOwnPropertyDescriptor, o = (i, t, l, r) => {
  for (var e = r > 1 ? void 0 : r ? d(t, l) : t, s = i.length - 1, a; s >= 0; s--)
    (a = i[s]) && (e = (r ? a(t, l, e) : a(e)) || e);
  return r && e && c(t, l, e), e;
};
let p = class extends n {
  constructor() {
    super(...arguments), this.paginationTheme = "", this.swiperOptions = {
      injectStyles: [g],
      pagination: {
        clickable: !0,
        renderBullet: (i, t) => `<span class="${t} ${this.hasAttribute("image-slider") ? "rlx-bullet--offset" : ""} ${this.paginationTheme ? `rlx-bullet--${this.paginationTheme}` : ""} rlx-bullet" data-bullet="${i}"></span>`
      },
      breakpoints: {
        768: {
          slidesPerView: Number(this.getAttribute("slides-per-view-md")) || 1,
          slidesPerGroup: Number(this.getAttribute("slides-per-group-md")) || 1
        },
        1024: {
          slidesPerView: Number(this.getAttribute("slides-per-view-lg")) || 1,
          slidesPerGroup: Number(this.getAttribute("slides-per-group-lg")) || 1
        }
      }
    };
  }
};
o([
  b({ type: String, attribute: "pagination-theme" })
], p.prototype, "paginationTheme", 2);
p = o([
  u("swiper-rlx")
], p);
export {
  p as SwiperRolex
};
